<template>
   <div>
     <div class="heading">
       <div class="vld-parent">
            <loading :active.sync="isLoading" loader= 'bars' 
            :can-cancel="true" 
            :on-cancel="onCancel"
            :is-full-page="fullPage"></loading>
        </div>
        <div v-html="info"></div>
      </div>
   </div>
</template>

<script>
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import axios from 'axios';
  export default {
    name: 'Promotionitem',
    components: {
      Loading
    },
    data () {
      return {
        msg: 'Promotionitem',
        isLoading: false,
        fullPage: true,
        info: null,
    }
  },
  methods: {
    onCancel() {
              console.log('User cancelled the loader.')
            }
  },
   mounted () {
    this.isLoading = true;
    axios
      .get(process.env.NODE_API + '/promotionitems')
      .then(response => {
        this.info = response.data[0].itemdata
      })
      .catch(error => {
        console.log(error)
        this.errored = true
      })
      .finally(() => this.isLoading = false)
  }
}

</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/sections/Promotionitem.vue